// extracted by mini-css-extract-plugin
module.exports = {"main":"search_results_main__2NdRh","itemName":"search_results_itemName__1a_Ab","selected":"search_results_selected__22mWa"};